"use client";

import styled from "@emotion/styled";

export const StyledContainer = styled.div`
  width: 100%;
  height: 100%;

  .pg-viewer-wrapper {
    overflow: auto !important;
  }

  .pg-viewer > * {
    width: inherit;
    height: 100%;
    overflow: auto;
  }

  .photo-viewer-container {
    padding: 1rem;
    display: block !important;
  }

  img {
    display: block !important;
    height: 100% !important;
    width: 100% !important;
    object-fit: contain;
  }

  canvas {
    display: block;
    margin-inline: auto;
  }
`;
